<template>
  <div class="staffing-page">
    <AlCard>
      <h2 class="month-card-header">
        <Localization message="staffing-monthly-summary" />
      </h2>
      <div class="secondary">
        Displaying values in {{ configuration.unitOfWork }}
      </div>
      <StaffingHeatmap
        :configuration="configuration"
        :monthData="months"
        :workloadTasks="workloadTasks"
      ></StaffingHeatmap>
    </AlCard>
    <AlCard id="staffing-tabs">
      <AlTabs :tabs="tabs" @tab-active="selectTab" defaultTab="0" />
      <router-view
        class="staffing-tab-body"
        @change="onChange"
        :configuration="configuration"
      ></router-view>
    </AlCard>
  </div>
</template>

<script>
import { AlCard, AlTabs } from "@playvox/almendra-components";
import StaffingHeatmap from "./StaffingHeatmap.vue";
import { Localization, Translator } from "@agyletime/wfm-vue-common";

export default {
  name: "StaffingPage",
  components: {
    AlCard,
    AlTabs,
    StaffingHeatmap,
    Localization,
  },
  mixins: [Translator],
  props: {
    configuration: {
      type: Object,
      required: true,
    },
    months: {
      type: Array,
      required: true,
    },
    workloadTasks: {
      type: Map,
      required: true,
    },
  },
  computed: {
    tabs() {
      return [
        {
          label: this.translate("capacity-planner-staffing-table-tab"),
          name: "staffing-table",
          to: "/view/:id/staffing/staffing",
        },
      ];
    },
  },
  methods: {
    selectTab(tab) {
      const matches = this.$router.currentRoute?.matched.map((m) => m.name);
      if (!this.$router.currentRoute || !matches.find((m) => m === tab.name)) {
        this.$router.push({
          name: tab.name,
          params: {
            ...this.$router.currentRoute.params,
          },
        });
      }
    },
    onChange() {},
  },
};
</script>

<style lang="scss" scoped>
.month-card-header {
  margin-bottom: 0.25rem;
}

.secondary {
  color: var(--color-black--eerie-60);
  font-size: 0.9em;
  font-weight: bold;
  margin-bottom: 1rem;
}

.card {
  margin-bottom: 1em;
}

#staffing-tabs {
  padding: 0;
  position: relative;
  overflow: visible;

  .staffing-tab-body {
    padding: 48px;
    min-height: 20rem;
  }
}
</style>

<style lang="scss">
.staffing-page {
  .multiselect.dr-multiselect .multiselect__tags {
    width: 15rem;
  }
  .edit-actions {
    margin-top: 1rem;
  }

  @media screen and (max-width: 899px) {
    .edit-row > * {
      min-width: 40%;
    }
  }
  @media screen and (max-width: 699px) {
    .edit-row > * {
      min-width: 100%;
    }
    .edit-actions {
      justify-content: flex-start;
    }
  }
}
</style>
